
<div #windowBody style="align-items:center; height: 100%; width: 100%;" data-testid="billingSubscriptionWin">
    <div *ngIf="title"><div class="b1Color h1Font title">{{title}}</div>
    </div>

    <div #body ></div>
</div>
 
